export const getSalePrice = (price: number, discount: number): number =>
  Math.round(price * (1 - discount / 100));
